module.exports = __webpack_public_path__ + "fonts/icons.eot"


/*****************
 ** WEBPACK FOOTER
 ** ./~/semantic-ui-css/themes/default/assets/fonts/icons.eot
 ** module id = 132
 ** module chunks = 0
 **/